import cx from 'classnames';
import * as React from 'react';

import Button, { Props as ButtonProps } from 'components/Button';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';

import './styles/AddButton.scss';

type AddButtonSize = 'large' | 'medium';

type Props = {
  size: AddButtonSize;
  stack?: boolean;
  children?: React.ReactNode;
  className?: string;
  listFooter?: boolean;
  onClick?: () => void;
} & ButtonProps;

type DefaultProps = {
  size: AddButtonSize;
};

class AddButton extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    size: 'medium',
  };

  renderBody() {
    const { children, stack } = this.props;

    const plus = <div className="AddButton-plus">+</div>;

    if (!children) {
      return plus;
    }

    if (stack) {
      return (
        <div>
          {plus}
          {children}
        </div>
      );
    } else {
      return (
        <MediaObject center gutter="xsmall">
          {plus}
          {children}
        </MediaObject>
      );
    }
  }

  render() {
    const { children, className, listFooter, onClick, size, stack, ...props } = this.props;

    if (children) {
      return (
        <Link
          {...props}
          noHover
          className={cx(
            'AddButton',
            'AddButton--link',
            listFooter && `AddButton--listFooter`,
            size && `AddButton--${size}`,
            stack && `AddButton--stack`,
            className
          )}
          onClick={onClick}>
          {this.renderBody()}
        </Link>
      );
    } else {
      return (
        <Button
          {...props}
          level="secondary"
          className={cx('AddButton', 'AddButton--button', size && `AddButton--${size}`, className)}
          onClick={onClick}>
          +
        </Button>
      );
    }
  }
}

export default AddButton;
